import React, {Component, useEffect} from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import {Transition} from "react-transition-group";

import "./style.scss";

class Modal extends Component {
    static propTypes = {
        size: PropTypes.oneOf([1200, 1000, 800, 700, 600, 500, 400]),
        closeIcon: PropTypes.bool,
        isOpen: PropTypes.bool,
        toggle: PropTypes.func,
        backdrop: PropTypes.oneOfType([
            PropTypes.bool,
            PropTypes.oneOf(["static"]),
        ]),
        scroll: PropTypes.bool,
    };

    static defaultProps = {
        size: 500,
        closeIcon: true,
        isOpen: false,
        backdrop: true,
        scroll: false,
    };

    _toggleAction = () => {
        this.props.toggle();
    };

    componentDidMount() {
        window.addEventListener('keydown', this.handleEsc);
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this.handleEsc);
    }

    handleEsc = (event) => {
        if (event.key === 'Escape' && this.props.isOpen) {
            this._toggleAction();
        }
    }

    render() {
        const {size, isOpen, backdrop, className = ""} = this.props;

        const classNames = cx(
            "sidebar-modal__content",
            size && `max-w-${size}`,
            className
        );

        const defaultStyle = {
            transition: "all .4s ease .2s",
            opacity: 0,
            visibility: "hidden",
        };

        const transitionStyles = {
            entering: {opacity: 0, visibility: "hidden"},
            entered: {
                opacity: 1,
                visibility: "visible",
                transition: "all .2s ease .0s",
            },
            exited: {opacity: 0, visibility: "hidden"},
        };

        const defaultModalStyle = {
            transition: "all .1s ease",
            opacity: 0,
            visibility: "hidden",
            transform: "translateX(100%)",
        };

        const transitionModalStyles = {
            entering: {opacity: 0, visibility: "hidden"},
            entered: {
                opacity: 1,
                visibility: "visible",
                transform: "translateX(0)",
                transition: "all .2s ease .1s",
            },
            exited: {opacity: 0, visibility: "hidden"},
        };

        return (
            <Transition
                in={isOpen}
                timeout={{
                    enter: 0,
                    exit: 200,
                }}
                unmountOnExit
            >
                {(state) => (
                    <div
                        className="sidebar-modal"
                        style={{
                            ...defaultStyle,
                            ...transitionStyles[state],
                        }}
                    >
                        <div
                            className="sidebar-modal__overlay"
                            onClick={() =>
                                backdrop === true ? this._toggleAction() : () => {
                                }
                            }
                            style={{
                                ...defaultStyle,
                                ...transitionStyles[state],
                            }}
                        >
                            {" "}
                        </div>
                        <div
                            className={classNames}
                            style={{
                                ...defaultModalStyle,
                                ...transitionModalStyles[state],
                            }}
                        >
                            {this.props.children}
                        </div>
                    </div>
                )}
            </Transition>
        );
    }
}

export default Modal;
